<template>
    <el-container v-loading="isShowLoading">
        <el-aside style="border-right: 1px solid #eeeeee;" v-show="treeVisible">
            <el-container>
                <el-main>
                    <el-tree ref="tree" :data="treeData" :expand-on-click-node="false" :highlight-current="true" :props="defaultProps"
                        accordion lazy :load="getNode" node-key="id" :default-expanded-keys="defaultOpen" v-loading="treeLoading"
                        @node-click="handleNodeClick"></el-tree>
                </el-main>
            </el-container>
        </el-aside>
        <el-main>
            <el-row>
                <el-form :model="filterData" :inline="true">
                    <el-form-item>
                        <el-input v-model="filterData.agencyCode" placeholder="请输入单位代码" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="filterData.agencyName" placeholder="请输入单位名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
           
            <el-table ref="singleTable" :data="recordData" highlight-current-row :row-style="{height:'30px'}" height="250" style="width: 100%;overflow: auto;" @row-click="onRowClick" 
            :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
                <!-- <el-table-column property="agencyCode" label="选择" align="center" width="100">
                    <template slot-scope="scope">
                        <el-radio :label="scope.$index+1" v-model="radio"></el-radio>
                    </template>
                </el-table-column> -->
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column property="agencyCode" label="单位代码" width="150" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="agencyName" label="单位名称" width="150" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="organName" label="权限机构" width="150"></el-table-column>
                <el-table-column property="areaName" label="主管机构" width="150"></el-table-column>
                <el-table-column property="agencyNo" label="单位编码" width="100" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="unitNature" label="单位性质" width="120"></el-table-column>
                <el-table-column property="licenceNo" label="领用证号" width="120"></el-table-column>
                <el-table-column property="address" label="通信地址" width="120" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="postcode" label="邮政编码" width="120"></el-table-column>
                <el-table-column property="financeDepartment" label="财政归口部门" width="120"></el-table-column>
                <el-table-column property="businessDepartment" label="业务主管部门" width="120"></el-table-column>
            </el-table>
            <el-row>
                <el-col :span="24">
                    <pagination v-show="pagination.total/pagination.pageSize>1" layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.total" :page.sync="pagination.page" :limit.sync="pagination.pageSize"
                        @pagination="onFilter" />
                </el-col>
            </el-row>
            <div style="height: 5px" v-show="pagination.total/pagination.pageSize < 2"></div>
            <el-row>
                <el-col :span="24">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addPlacePage" v-bind:disabled="enableBtn.xz">新增</el-button>
                    <el-button type="primary" size="small" icon="el-icon-edit" @click="updatePlace" v-bind:disabled="enableBtn.xg">修改</el-button>
                    <el-button type="primary" size="small" icon="el-icon-check" @click="enablePlace('Y')"
                        v-bind:disabled="enableBtn.qy">启用</el-button>
                    <el-button type="primary" size="small" icon="el-icon-close" @click="enablePlace('N')"
                        v-bind:disabled="enableBtn.jy">禁用</el-button>
                    <el-button type="primary" size="small" icon="el-icon-download" @click="onDown" v-bind:disabled="enableBtn.tb">同步</el-button>
                </el-col>
            </el-row>
            <el-table ref="singleTable" :data="recordData1" highlight-current-row style="width: 100%" :row-style="{height:'30px'}" height="250" 
            :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
                <el-table-column property="placeCode" label="选择" align="center" width="100">
                    <template slot-scope="scope">
                        <el-radio :label="scope.$index+1" v-model="radio1" @change.native="getCurrentRow(scope.row)"></el-radio>
                    </template>
                </el-table-column>
                <el-table-column property="placeCode" label="开票点编码" align="center"></el-table-column>
                <el-table-column property="placeName" label="开票点名称" align="center" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="level" label="开票点级次" align="center"></el-table-column>
                <el-table-column property="isValid" label="开票点状态" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isValid == 'Y'">
                            <i class="el-icon-success" style="color: #67C23A"></i>启用
                        </div>
                        <div v-else-if="scope.row.isValid == 'N'">
                            <i class="el-icon-remove" style="color: #eeeeee"></i>禁用
                        </div>
                    </template></el-table-column>
                <el-table-column property="updateTime" label="更新时间"></el-table-column>
            </el-table>
            <el-row>
                <el-col :span="24">
                    <pagination v-show="pagination1.total/pagination1.pageSize>1" layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination1.total" :page.sync="pagination1.page" :limit.sync="pagination1.pageSize"
                        @pagination="onFilter1" />
                </el-col>
            </el-row>

            <div style="height: 60px"></div>
            <el-drawer :visible.sync="layout.edit" :show-close="false" :wrapperClosable="false" :withHeader="false"
                :size="pageWidth + 'px'" direction="rtl" custom-class="demo-drawer" style="top: 67px">
                <div class="demo-drawer-content">
                    <Entity v-if="layout.edit" @back="back" @reload="onFilter1" v-bind:entity="entityData" ref="itemPanel"></Entity>
                </div>
            </el-drawer>
        </el-main>
    </el-container>
</template>

<script>
    import Entity from "./Entity.vue";
    import _ from "lodash";

    let _kits, _table, _table1;
    export default {
        components: {
            Entity
        },
        data() {
            return {
                radio: "",
                radio1: "",
                // 树
                defaultOpen: [],
                templateSelection: {},
                defaultProps: {
                    children: "children",
                    label: "name",
                    pid: "pId"
                },
                // loading-tag
                treeLoading: false,
                isShowLoading: true,
                pageWidth: 600,
                //页面布局相关
                layout: {
                    loading: true,
                    width: 600,
                    wd: "80%",
                    edit: false
                },
                //数据绑定相关
                filterData: {
                    agencyCode: "",
                    agencyName: ""
                }, //过滤信息
                enableBtn: { //控制启用禁用
                    qy: true,
                    jy: true,
                    tb: true,
                    xz: true,
                    xg: true
                },
                recordData: [], //展示信息
                recordData1:[],
                pagination: {
                    total: 0,
                    page: 1,
                    pageSize: 100
                }, //分页信息
                pagination1: {
                    total: 0,
                    page: 1,
                    pageSize: 100
                }, //分页信息
                treeData: [], // 列表treeData
                agencyInfo:{
                    agencyCode: "",
                    agencyName: "",
                    agencyNo: ""
                },
                entityData: {}, //具体某一项信息
                agencyNum: 0, //树结构中的开票单位数量
                agencyXx: []
            };
        },
        methods: {
            handleNodeClick(data, node, el) {
                this.recordData= [];
                this.recordData1= [];
                this.filterData.jgDm = data.id;
                this.init();
                this.enableBtn.xz = true;
                this.enableBtn.xg = true;
                this.enableBtn.qy = true;
                this.enableBtn.jy = true;
                this.enableBtn.tb = true;
            },
            onRowClick(row, column, event) {
                this.agencyInfo.agencyCode = row.agencyCode;
                _table1.load();
                this.enableBtn.xz = false;
                this.enableBtn.xg = false;
                this.enableBtn.qy = false;
                this.enableBtn.jy = false;
                this.enableBtn.tb = false;
            },
            addPlacePage() {
                if(this.filterData.jgDm == null){
                    return;
                }
                this.entityData = {
                    agencyCode: this.agencyInfo.agencyCode,
                };
                this.layout.edit = true
            },
            updatePlace() {
                if (this.checkSelect()) {
                    return;
                }
                // this.entityData = {
                //     agencyCode: this.agencyInfo.agencyCode,
                //     placeCode: this.templateSelection.placeCode
                // };
                this.entityData = this.templateSelection
                this.entityData.agencyCode = this.agencyInfo.agencyCode
                this.layout.edit = true;
            },
            onDel() {
                if (this.checkSelect()) {
                    return;
                }
                _kits.confirm({
                    text: "确定删除单位开票点?",
                    yes: () => {
                        this.layout.loading = true
                        _kits.message("正在删除")
                        _kits.api.update(
                            "DELAGENCYPLACE", {
                                agencyCode: this.agencyInfo.agencyCode,
                                placeCode: this.templateSelection.placeCode
                            },
                            () => {
                                _table1.load();
                                this.radio1="";
                                this.templateSelection= {};
                            }
                        )
                    }
                });
            },
            onDown() {
                this.layout.loading = true
                _kits.message("正在同步")
                _kits.api.update(
                    "DOWNAGENCYPLACE", {
                        agencyCode: this.agencyInfo.agencyCode
                    },
                    () => {
                        _table1.load();
                        this.radio1="";
                        this.templateSelection= {};
                    }
                )
            },
            enablePlace(isValid) {
                if (this.checkSelect()) {
                    return;
                }
                this.layout.loading = true
                _kits.message("正在更新状态")
                _kits.api.update(
                    "ENABLEAGENCYPLACE", {
                        agencyCode: this.agencyInfo.agencyCode,
                        placeCode: this.templateSelection.placeCode,
                        isValid: isValid
                    },
                    () => {
                        _table1.load();
                        this.radio1="";
                        this.enableBtn.qy = true;
                        this.enableBtn.jy = true;
                        this.templateSelection= {};
                    }
                )
            },
            checkSelect() {
                if (this.templateSelection.placeCode == undefined) {
                    this.$alert("请先选择一条记录");
                    return true;
                }
                return false;
            },
            onFilter() {
                this.layout.loading = true;
                _table.load();
                this.enableBtn.xz = true;
                this.enableBtn.xg = true;
                this.enableBtn.qy = true;
                this.enableBtn.jy = true;
                this.enableBtn.tb = true;
            },
            onFilter1() {
                this.layout.loading = true;
                _table1.load();
            },
            init() {
                this.radio = "";
                this.radio1 = "";
                this.templateSelection= {};
                _table.load();
            },
            back() {
                this.layout.edit = false;
                this.radio = "";
                this.radio1 = "";
                this.templateSelection= {};
            },
            getCurrentRow(row) { //获取选中数据
                this.templateSelection = row;
                if (row.isValid == "Y") {
                    this.enableBtn.qy = true;
                    this.enableBtn.jy = false;
                } else {
                    this.enableBtn.qy = false;
                    this.enableBtn.jy = true;
                }
            },
            getNode(node, resolve) {
                this.recordData= [];
                this.recordData1= [];
                this.enableBtn.xz = true;
                this.enableBtn.xg = true;
                let dealedData = [];
                let jkdm = "";
                if (!node.key) {
                    jkdm = "GETORGANTREEROOT";
                } else {
                    jkdm = "GETORGANTREENODE";
                }
                _kits.api.call(
                    jkdm, {
                        jgDm: node.key
                    },
                    result => {
                        this.treeLoading = false;
                        if (result.returnCode == "0000") {
                            for (let i = 0; i < result.data.length; i++) {
                                let type = result.data[i].type;
                                if (type == "01") {
                                    result.data[i].icon = "el-icon-house";
                                }
                            }
                            resolve(result.data);
                            let currentKey = this.$refs.tree.getCurrentKey();
                            if (jkdm == "GETORGANTREEROOT") {
                                if (currentKey != result.data[0].id) {
                                    node = this.$refs.tree.getNode(result.data[0].id); // 通过节点id找到对应树节点对象
                                    this.$refs.tree.setCurrentKey(node.key);
                                    this.filterData.jgDm = result.data[0].id;
                                    this.defaultOpen = [result.data[0].id];
                                    // this.init();
                                }
                            } else {
                                if (currentKey != node.id) {
                                    this.$refs.tree.setCurrentKey(node.key);
                                }
                            }
                        } else {
                            this.$message.error(result.returnMsg);
                        }
                    }
                );
            },
            dealAgency(datas) {
                //遍历树  获取id数组
                for (var i in datas) {
                    if (datas[i].type == "2") {
                        this.agencyNum++;
                        this.agencyXx.push(datas[i]);
                    }
                    if (datas[i].children && datas[i].children.length > 0) {
                        this.dealAgency(datas[i].children);
                    }
                }
            }
        },
        created() {
            this.pageWidth = window.innerWidth - 200;
            _kits = this.$kits();
            _table = _kits.table(
                "GETAGENCYBYORGANID",
                () => {
                    this.isShowLoading = true;
                    return Object.assign({}, this.filterData, this.pagination);
                },
                result => {
                    this.isShowLoading = false;
                    this.recordData = result.list;
                    this.pagination.total = Number.parseInt(result.total);
                }
            );
            _table1 = _kits.table(
                "GETAGENCYPLACEBYAGENCYCODE",
                () => {
                    this.isShowLoading = true;
                    return Object.assign({}, this.agencyInfo, this.pagination1);
                },
                result => {
                    this.isShowLoading = false;
                    this.recordData1 = result.list;
                    this.pagination1.total = Number.parseInt(result.total);
                }
            );
            //this.init();
            _kits = this.$kits();
             _kits.api.call("AGENCYTREE", {}, result => {
                if (result.data && result.data.length > 0) {
                    this.dealAgency(result.data);
                    if (this.agencyNum == 1) {
                        this.treeVisible = false;
                        this.filterData.jgDm = this.agencyXx[0].pid;
                        _table.load()
                    }else if(this.agencyNum == 0){
                        this.treeVisible = false;
                        this.isShowLoading = false;
                    }else{
                        this.treeVisible = true;
                        this.isShowLoading = false;
                        _table.load()
                    }
                }
            });
        },
        computed: {},
        mounted() {
            this.isShowLoading = false;     
        }
    };
</script>
<style scoped>
</style>
